/*
 * The job statuses, as the API stores them.
 *
 * Was an Angular `constant` in app.js (step 31 of #614). Only jobService and bookingService read
 * it, and both are plain modules now.
 */
export default {
  QUOTING: 'quoting',
  IN_PROGRESS: 'inprogress',
  INVOICED: 'invoiced',
}
